<script>
    import { onMount } from "svelte";
    import RangeSlider from "svelte-range-slider-pips";
    import { processImage } from "../imageTools";

    export let histogramWidth;
    let useCanvasWidth = true;
    export let canvasWidth;
    export let zoom;

    // Min and max threshold values. Less than min value will be changed to black, more than max value white.
    export let minHistogramThreshold;
    export let maxHistogramThreshold;

    // Source image CanvasRenderingContext2D. We read imagedata from this.
    export let sourceCanvas;

    // Internal variable, just to avoid calling sourceCanvas.getContext('2d') every time we change slider.
    let sctx;

    // Destination image canvas. We draw a new image when we change the histogram.
    export let manipulationCanvas;

    // DEBUG: $: console.log('HISTOGRAM SOURCE CANVAS UPDATED: ', sourceCanvas);
    // DEBUG: $: console.log('HISTOGRAM MANIPULATION CANVAS UPDATED: ', manipulationCanvas);

    $: {
        if (useCanvasWidth) {
            histogramWidth = canvasWidth;
        }
        sctx = sourceCanvas.getContext("2d");
        processImage(
            sctx.getImageData(0, 0, canvasWidth * zoom, canvasWidth * zoom),
            manipulationCanvas,
            minHistogramThreshold,
            maxHistogramThreshold
        );
    }

    // Adjust (recalculate) histogram when slider stops or a moment after it changed last
    let timeout;
    async function onHistogramAdjustChange(ev) {
        //console.log('HISTOGRAM CHANGE');
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            minHistogramThreshold = ev.detail.values[0];
            maxHistogramThreshold = ev.detail.values[1];
            adjustHistogram();
        }, 500);
    }

    async function onHistogramAdjustStop(ev) {
        //console.log('HISTOGRAM STOP');
        clearTimeout(timeout);
        minHistogramThreshold = ev.detail.values[0];
        maxHistogramThreshold = ev.detail.values[1];
        adjustHistogram();
    }

    async function adjustHistogram() {
        let sourceImgData = sctx.getImageData(0, 0, canvasWidth * zoom, canvasWidth * zoom);
        await processImage(sourceImgData, manipulationCanvas, minHistogramThreshold, maxHistogramThreshold);
    }

    onMount(() => {
        // If histogramWidth is not set, use the canvasWidth. If that is not defined, use 512px;
        if (!histogramWidth) {
            useCanvasWidth = true;
            histogramWidth = canvasWidth;
        } else {
            useCanvasWidth = false;
        }
        if (!histogramWidth) histogramWidth = 512;
    });
</script>

<div style="--histogramWidth:{histogramWidth}px; margin-bottom: 20px;">
    <canvas id="canvasHistogram" width={histogramWidth} height="150" />
    <RangeSlider
        id="histogramSlider"
        values={[minHistogramThreshold, maxHistogramThreshold]}
        max={255}
        range
        pips
        float
        first="label"
        last="label"
        springValues={{stiffness: 1, damping:1}}
        on:change={onHistogramAdjustChange}
        on:stop={onHistogramAdjustStop} />
</div>

<style>
    #canvasHistogram {
        border: solid 1px #999;
        background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"%3E%3Cg fill="%239C92AC" fill-opacity="0.4"%3E%3Cpath fill-rule="evenodd" d="M0 0h4v4H0V0zm4 4h4v4H4V4z"/%3E%3C/g%3E%3C/svg%3E');
        margin: auto;
        display: flex;
    }

    :global(#histogramSlider) {
        width: var(--histogramWidth);
        margin: auto;
    }
</style>
